import type { SVGProps } from 'react';
const SvgWbIridescent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#wb_iridescent_svg__a)">
      <path
        fill="currentColor"
        d="M5 14.5h14v-6H5v6ZM11 .55V3.5h2V.55h-2Zm8.04 2.5-1.79 1.79 1.41 1.41 1.8-1.79-1.42-1.41ZM13 22.45V19.5h-2v2.95h2Zm7.45-3.91-1.8-1.79-1.41 1.41 1.79 1.8 1.42-1.42ZM3.55 4.46l1.79 1.79 1.41-1.41-1.79-1.79-1.41 1.41Zm1.41 15.49 1.79-1.8-1.41-1.41-1.79 1.79 1.41 1.42Z"
      />
    </g>
    <defs>
      <clipPath id="wb_iridescent_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWbIridescent;
